import { render, staticRenderFns } from "./form-5A.vue?vue&type=template&id=4358710b&"
import script from "./form-5A.vue?vue&type=script&lang=js&"
export * from "./form-5A.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports